module.exports = __webpack_public_path__ + "media/img/apple-icon-76x76-a8471e0d702bfcbbff3316597ed490fe.png";